<template>
  <BaseModal :visible="visible" @close="handleClose" :withHeader="true">
    <div class="modalContent">
      <div class="main">
        <div class="couponListContainer">
          <CouponItem
            v-for="couponItem in couponsData"
            :data="couponItem"
            :key="couponItem.id"
            @reportEvent="handleReportEvent"
          />
        </div>
        <div class="note">{{ isOwned ? '奖励已放入您的账户' : '' }}</div>
      </div>
      <div class="useBtn" v-if="isOwned" @click="handleUseCoupon">
        去使用
      </div>
    </div>
  </BaseModal>
</template>
<script>
import BaseModal from './BaseModal';
import CouponItem from './CouponItem';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';

export default {
  components: { BaseModal, CouponItem },
  watch: {
    visible: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        // 埋点
        this.reportExpo();
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isOwned: {
      type: Boolean,
      default: false
    },
    couponsData: {
      type: Array,
      require: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
      this.$emit('reportEvent', {
        event: 'boost_coupon_popup_invite_click',
        module_name: this.isOwned ? '奖励详情弹窗-已领取' : '奖励详情弹窗',
        button_name: '退出icon'
      });
    },
    handleReportEvent() {},
    handleUseCoupon() {
      const coupon = this.couponsData && this.couponsData[0];
      if (coupon) {
        useCoupon(coupon.businessType);
      }
      this.$emit('reportEvent', {
        event: 'boost_coupon_popup_invite_click',
        module_name: '奖励详情弹窗-已领取',
        button_name: '去使用'
      });
    },
    reportExpo() {
      this.$emit('reportExpoEvent', {
        event: 'boost_coupon_invite_expo',
        module_name: this.isOwned ? '奖励详情弹窗-已领取' : '奖励详情弹窗'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.modalContent {
  .main {
    background: #ffe3cb;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 0 0 20px 20px;

    .couponListContainer {
      margin: 20px auto 0;
      width: 556px;
      max-height: 570px;
      overflow-y: auto;
      background: #ffd5af;
      border-radius: 16px;
      padding: 23px 18px;
      box-sizing: border-box;
    }

    .note {
      height: 80px;
      color: #b95001;
      font-size: 28px;
      .fc;
    }
  }

  .useBtn {
    margin: 40px auto 0;
    width: 500px;
    height: 88px;
    background: linear-gradient(#ff0044 0%, #ff4153 38%, #fd515f 99%);
    border-radius: 44px;
    font-size: 36px;
    color: #fff;
    .fc;
  }
}
</style>
